<!-- TRANSACTION DETAILS -->
<app-loader [loading]="isLoading" [overlay]="true"></app-loader>
<div *ngIf="transaction">
  <a class="link bottom-spacer" (click)="toList()">
    <mat-icon class="svg-icon" [svgIcon]="'arrow_left'"></mat-icon>
    <span>{{'general.api_transaction_exit' | translate}}</span>
  </a>
  <div class="heading-1 mobile">{{'general.api_transaction_number' | translate}}&nbsp;{{transaction.id}}</div>
  <mat-tab-group class="mobile dynamic-body" #tabGroup mat-align-tabs="left" animationDuration="0ms" (selectedIndexChange)="changeTab($event)">
    <mat-tab label="{{ 'general.api_transaction_details' | translate }}"></mat-tab>
    <mat-tab label="{{ 'general.api_transaction_tickets' | translate }}"></mat-tab>
    <mat-tab label="{{ 'general.api_transaction_audit_logs' | translate }}"></mat-tab>
  </mat-tab-group>
  <div class="content-with-sidebar">
    <div class="content" *ngIf="!utilService.isMobile || selectedMobileTab !== 'details'">
      <div class="flex space-between desktop">
        <div class="heading-1">{{'general.api_transaction_number' | translate}}&nbsp;{{transaction.id}}</div>
        <div class="flex flex-wrap bottom-spacer" *ngIf="!utilService.isMobile">
          <ng-container *ngTemplateOutlet="actions"></ng-container>
        </div>
      </div>
      <div class="flex mobile bottom-spacer" *ngIf="utilService.isMobile && selectedMobileTab === 'tickets'">
        <ng-container *ngTemplateOutlet="actions"></ng-container>
      </div>
      <mat-tab-group class="top-spacer-negative" mat-align-tabs="left" animationDuration="0ms" *ngIf="!utilService.isMobile">
        <mat-tab [label]="'general.api_transaction_general_info' | translate">
          <ng-container *ngTemplateOutlet="ticketsTable"></ng-container>
        </mat-tab>
        <mat-tab [label]="'general.api_transaction_audit_logs' | translate" *ngIf="canSeeAuditLogs">
          <mat-card appearance="outlined">
            <audit-log-table [pageData]="auditLogPage" [(page)]="auditPageNumber" (pageChange)="getAuditLogsAndTriggerUpdate()" [showAction]="true"></audit-log-table>
          </mat-card>
        </mat-tab>
      </mat-tab-group>
      <mat-card appearance="outlined" class="mobile" *ngIf="utilService.isMobile && selectedMobileTab === 'tickets'">
        <div class="listing-header" *ngIf="clickableTickets?.length > 0">
          <mat-checkbox (change)="toggleAll($event)"
                        [checked]="areAllSelected()" [indeterminate]="areSomeSelected()" [disabled]="!clickableTickets.length || this.isRefunded"></mat-checkbox>
          <span class="medium">{{ 'general.api_transactions_select_all' | translate }}</span>
        </div>
        <ng-container *ngFor="let event of transaction.cart.events">
          <div class="listing-block" [ngClass]="{'text-muted': ticket.refunded || isRefunded}" *ngFor="let ticket of (this.isLegacy ? event.legacyTickets : event.tickets)">
            <div class="header-block flex space-between bottom-spacer">
              <div class="flex" [ngClass]="{'no-gap': !isTicketClickable(ticket.id) || this.isRefunded}">
                <div>
                  <mat-checkbox (change)="toggleTicket($event, ticket.id)"
                                [checked]="isTicketSelected(ticket.id)" *ngIf="isTicketClickable(ticket.id) && !this.isRefunded"></mat-checkbox>
                </div>
                <div>
                  <div class="heading-5 no-margin">
                    {{'general.api_cart_table_ticket_id' | translate}} {{ticket.id}}
                  </div>
                  <span class="medium" *ngIf="hasRefundRights && !isRefunded">
                    <ng-container *ngTemplateOutlet="tableRefundBlock; context: {item: ticket}"></ng-container>
                  </span>
                </div>
              </div>
              <div>
                <ng-container *ngIf="hasGiftTicketReminderEnabled(event.reminderDays) && isCompatibleTicket(ticket.id)">
                  <button mat-button class="input-button icon-button" *ngIf="!ticketReminderEmailMap.get(ticket.id)" (click)="openGiftTicketReminderModal(ticket)"
                          [matTooltip]="('general.api_cart_gift_ticket_reminder' | translate)">
                    <mat-icon class="svg-icon" [svgIcon]="'bell'"></mat-icon>
                  </button>
                  <button mat-flat-button class="icon-button" color="primary" *ngIf="ticketReminderEmailMap.get(ticket.id)" (click)="openGiftTicketReminderModal(ticket)"
                          [matTooltip]="ticketReminderEmailMap.get(ticket.id)">
                    <mat-icon class="svg-icon" [svgIcon]="'bell_notification'"></mat-icon>
                  </button>
                </ng-container>
              </div>
            </div>
            <table class="mobile-max-width bottom-spacer">
              <tbody>
              <tr>
                <td class="bold">{{'general.api_cart_table_title' | translate}}</td>
                <td class="align-right">
                  <span class="medium">{{ event.title | translateValue }}</span>
                  <ng-container *ngIf="isLegacy">
                    <br>{{ event.venueTitle }}
                  </ng-container>
                  <div class="flex flex-end" *ngIf="!isLegacy">
                    <ng-container *ngTemplateOutlet="newBoVenueTitle; context: { item: event }"></ng-container>
                  </div>
                </td>
              </tr>
              <tr *ngIf="!event.isSeason">
                <td class="bold">{{ 'general.api_cart_table_date' | translate }}</td>
                <td class="align-right medium white-space-pre-line">{{ event.eventDate | period: { hasTimeInPeriod: true } }}</td>
              </tr>
              <tr>
                <td class="bold">{{'general.api_cart_table_type' | translate}}</td>
                <td class="align-right">
                  <span class="medium">
                    <ng-container *ngIf="isLegacy">
                      {{ ticket.priceTypeName | translate }}
                    </ng-container>
                    <ng-container *ngIf="!isLegacy">
                      {{ ticket.ticketTypeName | translateValue }}
                    </ng-container>
                  </span>
                  <ng-container *ngIf="ticket.insurance">
                    <br>+ {{ ticket.insurance.name | translate }}
                    <ng-container *ngIf="ticket.insurance.insuranceFee">
                      &nbsp; {{ 'general.api_cart_insurance_commission' | translate }} &nbsp;/&nbsp; {{ 'general.api_cart_insurance' | translate }}
                    </ng-container>
                  </ng-container>
                </td>
              </tr>
              <tr *ngIf="isLegacy">
                <td class="bold">{{ 'general.api_cart_table_sector' | translate }}</td>
                <td class="align-right medium">{{ ticket.sectorName | translate }}</td>
              </tr>
              <tr *ngIf="isLegacy && ticket.row">
                <td class="bold">{{ 'general.api_cart_table_row' | translate }}</td>
                <td class="align-right medium">{{ ticket.row }}</td>
              </tr>
              <tr *ngIf="isLegacy && ticket.row">
                <td class="bold">{{ 'general.api_cart_table_seat' | translate }}</td>
                <td class="align-right medium">{{ ticket.place }}</td>
              </tr>
              <tr>
                <td>
                  <span class="bold">{{'general.api_cart_table_price' | translate}}</span>
                </td>
                <td class="align-right">
                  <span class="heading-5">{{ ticket | ticketPrice:true }}</span>
                  <ng-container *ngIf="ticket.insurance">
                    <br>{{ ticket.insurance.commissionFee | price }}
                    <ng-container *ngIf="ticket.insurance.insuranceFee">
                      &nbsp;/&nbsp;{{ ticket.insurance.insuranceFee | price }}
                    </ng-container>
                  </ng-container>
                </td>
              </tr>
              </tbody>
            </table>
            <hr class="no-margin">
          </div>
        </ng-container>
      </mat-card>
      <mat-card appearance="outlined" class="mobile" *ngIf="selectedMobileTab === 'auditLogs'">
        <audit-log-table [pageData]="auditLogPage" [(page)]="auditPageNumber" (pageChange)="getAuditLogsAndTriggerUpdate()" [showAction]="true"></audit-log-table>
      </mat-card>
    </div>
    <div class="sidebar" *ngIf="!utilService.isMobile || selectedMobileTab === 'details'">
      <!-- DETAILS -->
      <ng-container *ngIf="!modalIsOpened">
        <app-section-header [title]="'general.api_transaction_details'"></app-section-header>
        <div class="flex flex-column">
          <div>
            <app-label-value *ngIf="transaction.referenceNumber && isLegacy" [singleLine]="true"
                             [label]="'general.api_transaction_reference_nr'" [value]="transaction.referenceNumber"></app-label-value>
            <app-label-value [singleLine]="true" [label]="'general.api_transactions_table_time'"
                             [value]="transaction.date | moment: {format: viewService.conf.dateTimeFormatWithSeconds, local: false}"></app-label-value>
            <app-label-value [singleLine]="true" [label]="'general.api_reports_salespoint'" [value]="transaction.salespoint.name"></app-label-value>
            <app-label-value *ngIf="transaction.seller?.firstName || transaction.seller?.lastName" [singleLine]="true"
                             [label]="'general.api_reports_seller'" [value]="transaction.seller?.firstName + ' ' + transaction.seller?.lastName"></app-label-value>
            <app-label-value *ngIf="transaction.customer" [singleLine]="true"
                             [label]="'general.api_reports_buyer'" [value]="formattedCustomer"></app-label-value>
            <app-label-value *ngIf="!isLegacy" [singleLine]="true" [label]="'general.api_transaction_delivery_email'" [value]="transaction.email"></app-label-value>
            <app-label-value *ngIf="transaction.invoiceUuid && (transaction.isTransactionOwner || isLegacy)" [singleLine]="true" [link]="true" (linkAction)="invoiceService.downloadInvoiceByUuid(transaction.invoiceUuid)"
                             [label]="'general.api_transaction_invoice'" [value]="transaction.invoiceNumber"></app-label-value>
          </div>
          <app-label-value *ngIf="transaction.cart.legacyPromocode?.name" [singleLine]="true"
                           [label]="'general.api_cart_code_promo'" [value]="cartService.cart.legacyPromocode?.name"></app-label-value>
          <!--<app-label-value *ngIf="transaction.cart.giftCards?.length" [singleLine]="true"
                           [label]="'general.api_cart_code_gift'" [template]="giftCardsTemplate"></app-label-value>
          <ng-template #giftCardsTemplate>
            <ng-container *ngFor="let giftCard of transaction.cart.giftCards">
              <ng-container *ngFor="let giftCode of giftCard.codes; let last = last">
                {{giftCode.code}} ({{giftCode.credit | price}})
                <ng-container *ngIf="!last">,&nbsp;</ng-container>
              </ng-container>
            </ng-container>
          </ng-template>-->
          <app-label-value *ngIf="transaction.cart.discountPercent" [singleLine]="true"
                           [label]="'general.api_cart_discount'" [value]="transaction.cart.discountPercent + '%'"></app-label-value>
          <div *ngIf="!invoiceGenerateInProgress && !transaction.invoiceUuid && authService.checkPrivileges(Privileges.INVOICE_GENERATE) && (transaction.isTransactionOwner || isLegacy)">
            <a class="link" (click)="openGenerateInvoiceModal(transaction)">
              <mat-icon class="svg-icon" [svgIcon]="'invoice'"></mat-icon>
              <span>{{ 'general.api_transactions_generate_invoice' | translate }}</span>
            </a>
          </div>
          <div *ngIf="!invoiceGenerateInProgress && transaction.invoiceUuid && (transaction.isTransactionOwner || isLegacy)" class="flex">
            <a class="link" (click)="openGenerateInvoiceModal(transaction)">
              <mat-icon class="svg-icon" [svgIcon]="'invoice'"></mat-icon>
              <span>{{ (authService.checkPrivileges(Privileges.INVOICE_CHANGE) ? 'general.api_transactions_change_invoice' : 'general.api_transactions_view_invoice') | translate }}</span>
            </a>
            <a class="link" (click)="openInvoiceEmailModal(transaction.invoiceUuid)">
              <mat-icon class="svg-icon" [svgIcon]="'e_mail'"></mat-icon>
              <span>{{ 'general.api_transactions_email_invoice' | translate }}</span>
            </a>
          </div>
        </div>
        <hr class="slim">
        <div class="flex flex-column">
          <app-label-value *ngIf="transaction.isPaymentSentForProcessing" [noValue]="true" [singleLine]="true"
                           [label]="'general.api_reports_payment_sent_for_processing'"></app-label-value>
          <app-label-value *ngIf="!authService.checkPrivileges(Privileges.PAYMENT_METHOD_CHANGE) || !isLegacy && !isRefunded" [singleLine]="true"
                           [label]="'general.api_reports_payment_type'" [value]="transaction.payments | paymentType"></app-label-value>
          <!--<app-label-value *ngIf="!isLegacy && !!(transaction.payments | paymentMethod)" [singleLine]="true" [label]="'general.api_transactions_payment_method'"
                           [value]="transaction.payments | paymentMethod"></app-label-value>-->
          <ng-container *ngIf="authService.checkPrivileges(Privileges.PAYMENT_METHOD_CHANGE)">
            <mat-form-field appearance="outline" class="no-hint" *ngIf="isLegacy">
              <mat-label>{{ 'general.api_reports_payment_type' | translate }}</mat-label>
              <mat-select (ngModelChange)="paymentChanged = true"
                          [(ngModel)]="paymentType" [ngModelOptions]="{standalone: true}">
                <mat-select-trigger>{{ ('general.api_cart_' + paymentType) | translate }}</mat-select-trigger>
                <mat-option *ngFor="let pt of paymentTypes" [value]="pt">
                  {{ ('general.api_cart_' + pt.toLowerCase()) | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="no-hint" *ngIf="!isLegacy && isRefunded">
              <mat-label>{{ 'general.api_transactions_payment_method' | translate }}</mat-label>
              <mat-select (ngModelChange)="paymentChanged = true" [disabled]="!transaction.isTransactionOwner"
                          [(ngModel)]="paymentMethod" [ngModelOptions]="{standalone: true}">
                <mat-option *ngFor="let pm of PaymentMethodValues" [value]="pm">
                  {{ ('general.api_transactions_payment_method_' + pm.toLowerCase()) | translate }}
                </mat-option>
                <mat-option *ngIf="canDoPaymentReversal" [value]=" PaymentMethodEnum.EveryPay">
                  {{ ('general.api_transactions_payment_method_' + PaymentMethodEnum.EveryPay.toLowerCase()) | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
          <app-text-input [type]="TextInputType.Email" [label]="'general.api_transaction_client_notification_email'" [disabled]="!(transaction.isTransactionOwner || isLegacy)"
                          [(value)]="transaction.clientNotificationEmail" (valueChange)="clientNotificationEmailChanged = true"></app-text-input>
          <app-text-input [type]="TextInputType.Textarea" [label]="'general.api_transaction_internal_comment'" [disabled]="!(transaction.isTransactionOwner || isLegacy)"
                          [(value)]="transaction.internalComment" (valueChange)="internalCommentChanged = true"></app-text-input>
          <!-- TRANSACTION TOTALS -->
          <app-totals-table [tableData]="totalsTableData"></app-totals-table>
          <!-- PAYMENTS -->
          <app-totals-table *ngIf="paymentsTableData?.body?.length" [tableData]="paymentsTableData"></app-totals-table>

          <button mat-flat-button color="primary" *ngIf="!isLegacy || (isLegacy && authService.checkPrivileges(Privileges.PAYMENT_METHOD_CHANGE))"
                  (click)="hasTransactionChanged && saveTransactionChanges()"
                  [disabled]="!isValidCustomerNotificationEmail() || !hasTransactionChanged">
            {{ 'general.api_transaction_save_changes' | translate }}
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #ticketsTable>
  <mat-card appearance="outlined" class="desktop" *ngIf="!utilService.isMobile">
    <!-- TICKET TABLE IMPLEMENTATIONS -->
    <ng-container *ngIf="transaction.cart.events.length">
      <div class="body-2 text-muted" *ngIf="hasRefundRights && refundableTickets.length && !canRefundTickets">
        <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
        {{ 'general.api_cart_tickets_not_refundable_warning_description' | translate }}
      </div>
      <app-data-table [(config)]="tableConfig" [(data)]="transaction.cart.events" [(selected)]="selectedTicketIds" [(clickable)]="clickableTickets"></app-data-table>
    </ng-container>
  </mat-card>
</ng-template>

<ng-template #tableTicketId let-item="item">
  <span class="title">{{ item.id }}</span>
  <div class="white-space-no-wrap" *ngIf="hasRefundRights && !isRefunded">
    <ng-container *ngTemplateOutlet="tableRefundBlock; context: {item}"></ng-container>
  </div>
</ng-template>

<ng-template #tableRefundBlock let-item="item">
  <ng-container *ngIf="isLegacy">
    {{ (!isCompatibleTicket(item.id) ? 'general.api_cart_table_ticket_recycled' : 'general.api_cart_table_ticket_not_exchangeable') | translate }}
  </ng-container>
  <ng-container *ngIf="isCompatibleTicket(item.id)">
    <ng-container *ngIf="isLegacy">/</ng-container>
    {{ (canRefundTicket(item.id) ? 'general.api_cart_table_ticket_refundable' : 'general.api_cart_table_ticket_non_refundable') | translate }}
  </ng-container>
  <ng-container *ngIf="!isLegacy && !isCompatibleTicket(item.id) && !isNotEventOwnerTicket(item.id)">
    {{ 'general.api_cart_table_ticket_recycled' | translate }}
  </ng-container>
  <ng-container *ngIf="!isLegacy && isNotEventOwnerTicket(item.id)">
    {{ 'general.api_cart_table_not_event_owner_ticket' | translate }}
  </ng-container>
</ng-template>

<ng-template #tableEvent let-item="item">
  <span class="title">{{ item.title | translateValue }}</span>
  <ng-container *ngIf="isLegacy">
    <br>{{ item.venueTitle }}
  </ng-container>
  <ng-container *ngIf="!isLegacy">
    <ng-container *ngTemplateOutlet="newBoVenueTitle; context: { item: item }"></ng-container>
  </ng-container>
</ng-template>

<ng-template #newBoVenueTitle let-item="item">
  <app-event-info-props [eventProps]="{venueTitle: item.venueTitle, onlineLocation: item.onlineLocation}"></app-event-info-props>
</ng-template>

<ng-template #tableDate let-item="item">
  <ng-container *ngIf="!item.isSeason">{{ item.eventDate | period: { hasTimeInPeriod: true } }}</ng-container>
</ng-template>

<ng-template #tableTicketType let-item="item">
  <span [ngClass]="{'title' : item.insurance}">
    <ng-container *ngIf="isLegacy">
      {{ item.priceTypeName | translate }}
    </ng-container>
    <ng-container *ngIf="!isLegacy">
      {{ item.ticketTypeName | translateValue }}
    </ng-container>
  </span>
  <ng-container *ngIf="item.insurance">
    <br>+ {{ item.insurance.name | translate }}
    <ng-container *ngIf="item.insurance.insuranceFee">
      &nbsp;{{ 'general.api_cart_insurance_commission' | translate }}&nbsp;/&nbsp;{{ 'general.api_cart_insurance' | translate }}
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #tableTicketPrice let-item="item">
  <span class="title white-space-no-wrap">{{ item | ticketPrice:true }}</span>
  <ng-container *ngIf="item.insurance">
    <br><span class="white-space-no-wrap">{{ item.insurance.commissionFee | price }}</span>
    <ng-container *ngIf="item.insurance.insuranceFee">
      &nbsp;/&nbsp;<span class="white-space-no-wrap">{{ item.insurance.insuranceFee | price }}</span>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #tableReminder let-item="item" let-parent="parent">
  <ng-container *ngIf="hasGiftTicketReminderEnabled(parent.reminderDays) && isCompatibleTicket(item.id)">
    <button mat-button class="input-button icon-button small" *ngIf="!ticketReminderEmailMap.get(item.id)" (click)="openGiftTicketReminderModal(item)"
            [matTooltip]="('general.api_cart_gift_ticket_reminder' | translate)">
      <mat-icon class="svg-icon" [svgIcon]="'bell'"></mat-icon>
    </button>
    <button mat-flat-button class="icon-button small" color="primary" *ngIf="ticketReminderEmailMap.get(item.id)" (click)="openGiftTicketReminderModal(item)"
            [matTooltip]="ticketReminderEmailMap.get(item.id)">
      <mat-icon class="svg-icon" [svgIcon]="'bell_notification'"></mat-icon>
    </button>
  </ng-container>
</ng-template>

<ng-template #actions>
  <ng-container *ngTemplateOutlet="serviceRefundButton"></ng-container>
  <ng-container *ngTemplateOutlet="reprintButton"></ng-container>
  <ng-container *ngTemplateOutlet="purchaseEmailButton"></ng-container>
</ng-template>

<ng-template #serviceRefundButton>
  <app-link *ngIf="hasRefundRights && !isRefunded"
            [link]="'general.api_transaction_refund'"
            [icon]="'refresh'"
            [disabled]="!selectedTicketIds.length || !refundableTickets.length || !areSelectedTicketsRefundable"
            (linkClicked)="selectedTicketIds.length > 0 && canRefundTickets && startRefundTickets()"></app-link>
</ng-template>

<ng-template #reprintButton>
  <app-link *ngIf="authService.checkPrivileges(Privileges.TRANSACTION_REPRINT) && !isRefunded"
            [link]="'general.api_transaction_print_tickets'"
            [icon]="'print'"
            [disabled]="!selectedTicketIds.length"
            (linkClicked)="printTickets()"></app-link>
</ng-template>

<ng-template #purchaseEmailButton>
  <app-link *ngIf="!isRefunded && authService.checkPrivileges([Privileges.TRANSACTION_REPRINT, Privileges.SALES], true)"
            [link]="'general.api_transaction_resend_purchase_email'"
            [icon]="'e_mail'"
            [disabled]="!selectedTicketIds.length"
            (linkClicked)="resendPurchaseEmail()"></app-link>
</ng-template>
